var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39692 7.00869C10.7218 7.00869 11.7958 5.93467 11.7958 4.60981C11.7958 3.28495 10.7218 2.21094 9.39692 2.21094C8.07206 2.21094 6.99805 3.28495 6.99805 4.60981C6.99805 5.93467 8.07206 7.00869 9.39692 7.00869Z",
    fill: "#84C70D",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39648 7.0088C10.7213 7.0088 11.7954 5.93478 11.7954 4.60992C11.7954 3.58506 11.1527 2.71031 10.2483 2.3667",
    stroke: "#588509",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6731 10.3786C13.8465 11.1601 13.0541 12.6674 11.6443 12.6674H6.34989C4.94004 12.6674 4.14769 11.1601 5.3211 10.3786C6.37362 9.67759 7.63765 9.26904 8.99709 9.26904C10.3565 9.26904 11.6205 9.67759 12.6731 10.3786Z",
    fill: "#84C70D",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36012 6.53323C6.79626 6.53323 7.96048 5.36901 7.96048 3.93288C7.96048 2.49674 6.79626 1.33252 5.36012 1.33252C3.92398 1.33252 2.75977 2.49674 2.75977 3.93288C2.75977 5.36901 3.92398 6.53323 5.36012 6.53323Z",
    fill: "#84C70D",
    fillOpacity: 0.4,
    stroke: "#588509",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22797 12.6677H2.4889C0.960637 12.6677 0.101742 11.0338 1.37371 10.1866C2.51463 9.42674 3.88481 8.98389 5.35843 8.98389C6.83205 8.98389 8.20224 9.42674 9.34316 10.1866C10.6151 11.0338 9.75623 12.6677 8.22797 12.6677Z",
    fill: "#84C70D",
    fillOpacity: 0.4,
    stroke: "#588509",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00684 12.6676H11.6444C13.0542 12.6676 13.8466 11.1603 12.6732 10.3787C12.3492 10.1629 12.0051 9.97485 11.6444 9.81787",
    stroke: "#588509",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.26698e74d29b405ab7a351a792786a92.svg";
export { ForwardRef as ReactComponent };